export enum TimelineKind {
    TEMPLATE = 0,
    MAIN = 1,
    CATCH_UP_MASTER = 2,
    BUYER = 3,
}

export const TimelineKinds = [
    { id: TimelineKind.TEMPLATE, name: 'Template' },
    { id: TimelineKind.MAIN, name: 'Main' },
    { id: TimelineKind.CATCH_UP_MASTER, name: 'Catch-up master' },
    { id: TimelineKind.BUYER, name: 'Buyer' },
];
